module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft7.c20d06ba.jpg";